import { useGet } from "./requestAPI/apiGet"
import { MarketoProgramObject } from "../types/APITypes";

export const useGetMarketoPrograms = () => 
    useGet<MarketoProgramObject[]>({
        url: 'settings/get-programs'
    }); 

    


